import { some, sumBy } from 'lodash';
import { AGE_RANGE_MIN_DIFFERENCE_CONSTRAINT } from 'containers/TargetingPeeqPage/Criteria/AgeTargetingCard/constants';

export const isOverlap = (rangeA, rangeB) =>
  rangeA.min <= rangeB.max && rangeA.max >= rangeB.min;

export const isIdenticalRanges = (rangeA, rangeB) =>
  rangeA.min === rangeB.min && rangeA.max === rangeB.max;

const ageCriterionValidator = (
  { values, hasQuotas } = {},
  { completes } = {},
) => {
  const errors = {};
  if (!values.length) {
    errors.noValueSelected = true;
  }

  const anyRangeWithWrongDifference = some(
    values,
    (range) => range.max - range.min < AGE_RANGE_MIN_DIFFERENCE_CONSTRAINT,
  );
  if (anyRangeWithWrongDifference) {
    errors.rangeDifference = true;
  }

  const anyRangeWithWrongOrder = some(values, (range) => range.max < range.min);
  if (anyRangeWithWrongOrder) {
    errors.rangeOrder = true;
  }

  const anyRangeOverlaps = some(values, (rangeA, indexA) =>
    some(
      values,
      (rangeB, indexB) => indexA !== indexB && isOverlap(rangeA, rangeB),
    ),
  );

  if (anyRangeOverlaps) {
    errors.rangeOverlap = true;
  }

  const hasIdenticalRanges = some(values, (rangeA, indexA) =>
    some(
      values,
      (rangeB, indexB) =>
        indexA !== indexB && isIdenticalRanges(rangeA, rangeB),
    ),
  );

  if (hasIdenticalRanges) {
    errors.identicalRanges = true;
  }

  if (hasQuotas) {
    const criterionQuotaSum = sumBy(values, 'quotaCompletes');
    const quotaSumError = completes && criterionQuotaSum < completes;
    if (quotaSumError) {
      errors.quotaSumError = true;
    }
  }

  return errors;
};

export default ageCriterionValidator;
